import React, { useEffect, useState } from "react";
import { MenuLateral } from "../../../../Components/MenuLateral/Index";
import { Header } from "../../../../Components/Header/";
import { Panel } from "../../../../Components/Panel";
import { useCartorio } from "../../../../Hooks/cartorio";
import { Container, AddUserButton } from "./styles";
import { TablePanel } from "../../../../Components/TablePanel";
import {
  IFuncionarioCartorio,
  useFuncionarioCartorio,
} from "../../../../Hooks/funcionarioCartorio";
import { UserPlus } from "react-feather";
import { ModalLoader } from "../../../../Components/ModalLoader";
import { Alert } from "../../../../Components/Error/Alert";
import { AddFuncionarioModal } from "../../../../Components/AddFuncionarioModal";
import { FaWarehouse } from "react-icons/fa";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import {
  IFuncionarioPrefeitura,
  useFuncionarioPrefeitura,
} from "../../../../Hooks/funcionarioPrefeitura";
export function Funcionarios() {
  const { cartorio, checarToken, cartorioIsLogged } = useCartorio();
  const {
    getfuncionariosPrefeitura,
    funcionariosPrefeitura,
  } = useFuncionarioPrefeitura();
  const {
    getfuncionariosCartorio,
    funcionariosCartorio,
  } = useFuncionarioCartorio();

  const {
    prefeituraIsLogged,
    prefeitura,
    checarTokenPrefeitura,
  } = usePrefeitura();

  const [ativos, setAtivos] = useState({} as IFuncionarioCartorio[]);
  const [inativos, setInativos] = useState({} as IFuncionarioCartorio[]);
  const [ativosPref, setAtivosPref] = useState({} as IFuncionarioPrefeitura[]);
  const [inativosPref, setInativosPref] = useState(
    {} as IFuncionarioPrefeitura[]
  );

  const [index, setIndex] = useState(1 as 1 | 2);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({
    title: "",
    message: "",
  });
  const [addFuncionarioModal, setAddFuncionarioModal] = useState(false);

  const [abas, setAbas] = useState([
    {
      title: "ATIVO",
      index: 1,
      execute: () => {
        setIndex(1);
        console.log("ATIVOS");
      },
      data: ativos,
    },
    {
      title: "INATIVO",
      index: 2,
      execute: () => {
        setIndex(2);
        console.log("INVATIVOS");
      },
      data: inativos,
    },
  ]);

  async function handleGetFuncionarios() {
    try {
      setLoading(true);
      if (cartorioIsLogged) {
        await checarToken();

        await getfuncionariosCartorio(cartorio.ID);
      } else if (prefeituraIsLogged) {
        await checarTokenPrefeitura();
        await getfuncionariosPrefeitura(prefeitura.ID);
      }
    } catch (error) {
      setError({
        title: "",
        message: "",
      });
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    handleGetFuncionarios();
  }, [cartorio.ID]);

  useEffect(() => {
    if (funcionariosCartorio) {
      if (funcionariosCartorio.length > 0) {
        setAtivos(
          funcionariosCartorio.filter((item) => {
            console.log(item);
            return item.ATIVO.trim() == "A";
          })
        );
        setInativos(
          funcionariosCartorio.filter((item) => {
            return item.ATIVO.trim() == "I";
          })
        );
      }
    }

    //console.log("inativos: ", inativos);
  }, [funcionariosCartorio]);

  useEffect(() => {
    if (funcionariosPrefeitura) {
      if (funcionariosPrefeitura.length > 0) {
        setAtivosPref(
          funcionariosPrefeitura.filter((item) => {
            console.log(item);
            return item.ATIVO.trim() == "A";
          })
        );
        setInativosPref(
          funcionariosPrefeitura.filter((item) => {
            return item.ATIVO.trim() == "I";
          })
        );
      }
    }

    //console.log("inativos: ", inativos);
  }, [funcionariosPrefeitura]);

  useEffect(() => {
    // console.log('ATIVOS-> ',ativos)
    // console.log('INATIVOS-> ',inativos)
  }, [ativos, inativos]);

  return (
    <Container>
      <MenuLateral
        titulo={prefeituraIsLogged ? prefeitura.NOME : cartorio.NOME}
      />
      <Panel
        children={
          <>
            <Panel
              children={
                <>
                 
                  <Header type={"FUNCIONÁRIOS"} />
                  <TablePanel
                    loading={
                      loading || error.message.length > 0 || addFuncionarioModal
                    }
                    abas={abas}
                    index={index}
                    conteudoTabelaFuncionario={
                      index == 1
                        ? prefeituraIsLogged
                          ? ativosPref
                          : ativos
                        : prefeituraIsLogged
                        ? inativosPref : inativos
                    }
                    tableHeader={
                      
                      cartorioIsLogged? [
                        "CODIGO",
                        "NOME",
                        "EMAIL",
                        "CPF",
                        "FONE",
                        "CELULAR",
                      ]:
                      [
                      "CODIGO",
                      "NOME",
                      "EMAIL",
                      "CPF",
                      "FONE",
                      "CELULAR",
                      "AVALIADOR",
                    ]}
                  />
                  <AddUserButton
                    onClick={() => {
                      setAddFuncionarioModal(true);
                    }}
                  >
                    <UserPlus size={"max(18px, 1.8vw)"} />
                  </AddUserButton>
                </>
              }
            />
            <Alert
              title={error.title}
              message={error.message}
              open={error.message.length > 0}
              onClose={() => {
                setError({ title: "", message: "" });
              }}
            />
            <ModalLoader loading={loading} />
            <AddFuncionarioModal
              open={addFuncionarioModal}
              onClose={() => setAddFuncionarioModal(false)}
            />
          </>
        }
      />
    </Container>
  );
}
